exports = module.exports = require("../../../../../../shared/frontend/node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.avatar-box .img-avatar {\n    width: 200px;\n    cursor: pointer;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /home/alarmplan/staging/shared/frontend/~/css-loader?{"minimize":false,"sourceMap":false}!/home/alarmplan/staging/shared/frontend/~/vue-loader/lib/style-compiler?{"id":"data-v-2f1bcf9c","scoped":false,"hasInlineConfig":true}!/home/alarmplan/staging/shared/frontend/~/vue-loader/lib/selector.js?type=styles&index=0!./src/views/Profile/Timeline.vue
// module id = 786
// module chunks = 1